<template>
  <section>
    <!--工具条-->
    <el-col :span="20" class="toolbar">
      <el-date-picker
        v-model="beginTime"
        type="datetime"
        placeholder="开始时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
      <el-date-picker
        v-model="endTime"
        type="datetime"
        placeholder="结束时间"
        size="small"
        format="yyyy-MM-dd HH:mm:ss">
      </el-date-picker>
        <el-col :span="3">
      <el-input placeholder="店铺编号" size="small" v-model="shopusid">
      </el-input>
    </el-col>
         <el-select v-model="selectRecordStatus" placeholder="是否删除" size="small" style="width: 150px">
        <el-option key="0" label="全部" value="200"></el-option>
        <el-option
          v-for="(item, index) in recordStatus"
          :key="index"
          :label="item"
          :value="index"
          size="small">
        </el-option>
      </el-select>
      <el-button type="primary"  size="small" @click="search">查询</el-button>
  

    </el-col>
   <el-col :span="4" class="toolbar">
      <el-input placeholder="商品名称" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>
 
   <el-table :data="tableData"
              border
              v-loading="listLoading">
                     <el-table-column
        label="店铺编号"
        prop="usid"
        align="center">
      </el-table-column>
        <el-table-column
        label="店铺名称"
        prop="dianpu_name"
        align="center"
         min-width="150">
      </el-table-column>
        <el-table-column
        label="商品编号"
        prop="pro_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="pro_name"
        align="center"
        min-width="500">
      </el-table-column>

      <el-table-column
        label="规格"
        prop="spec_name"
        align="center">
      </el-table-column>
         <el-table-column
        label="数量"
        prop="count"
        align="center">
      </el-table-column>
         <el-table-column
        label="收藏价格"
        prop="col_price"
        align="center">
      </el-table-column>
            <el-table-column
            label="当前价格"
               prop="price"
            align="center">
            <template scope="scope">   
        <el-button type="danger" v-if="scope.row.price > scope.row.col_price"  size="small" >{{scope.row.price}}</el-button>
         <el-button type="primary" v-if="scope.row.price == scope.row.col_price"  size="small" >{{scope.row.price}}</el-button>
       <el-button type="success" v-if="scope.row.price < scope.row.col_price"  size="small" >{{scope.row.price}}</el-button>
      </template>
    </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="修改时间"
        prop="update_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="记录状态"
        align="center">
        <template scope="scope">
            <el-button type="primary" v-if="scope.row.status == 0"  size="small" >正常</el-button>
            <el-button type="danger" v-if="scope.row.status == 1"  size="small" >删除</el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>


  </section>
</template>

<script>
  import config from '../../config';
    import {formatDate} from '../../static/js/date.js';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return { 
        recordStatus:basicdata.status,
        selectRecordStatus: "200",
        beginTime: '',
        endTime: '',
        shopusid: '',
        tableData: [],
        total:0,
        page:1,
        pageSize:30,
        listLoading: false,
        expands: [],
        getRowKeys(row) {
          return row._id;
        },
        query: '',
        status: basicdata.status,
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        let url = config.api_url + '/shopcar/page'
        this.beginTime = typeof(this.beginTime) != "string" ? formatDate(this.beginTime, "yyyy-MM-dd hh:mm:ss") : this.beginTime;
            this.endTime = typeof(this.endTime) != "string" ? formatDate(this.endTime, "yyyy-MM-dd hh:mm:ss") : this.endTime;
            var query = this.beginTime + "|" + this.endTime+ "|" + this.shopusid+ "|" + this.selectRecordStatus+ "|"  + this.query ;
        this.$axios.post(url, {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      }
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
    .rightsearch{
        float: right;
    }
    .piclist {
      width: 100%;
    }
    .piclist>a {
      width: 30%;
      float: left;
      padding: 0 10px 10px 10px;
    }
    .piclist>a>img {
     width: 100%;
     height: 100px;
    }
</style>


// WEBPACK FOOTER //
// shopcar.vue?2f6c709c